import { render, staticRenderFns } from "./TabTargeting.vue?vue&type=template&id=6573288f"
import script from "./TabTargeting.vue?vue&type=script&lang=js"
export * from "./TabTargeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports